import { http } from 'connex-cds';

export default {
  helloWorld: ({ queryKey, data }) => {
    const [, entityRef] = queryKey;
    return http.post({
      apiName: 'aifeed-exp',
      path: `/${entityRef}`,
      data,
      useLoginToken: true,
      queryParams: { firstName: 'Mike', lastName: 'Giddens' },
    });
  },
  updateHelloWorld: ({ entityRef, data }) => {
    return http.patch({
      apiName: 'aifeed-exp',
      path: `/${entityRef}`,
      data,
      queryParams: { firstName: 'Mike', lastName: 'Giddens' },
    });
  },
};
